import {
  Adjustments,
  Briefcase,
  Edit,
  Home,
  Plus,
  Search,
} from "tabler-icons-react";
import routeNames from "../../../routes/routeNames";

export const links = [
  {
    label: "Home",
    link: routeNames.jobSeeker.dashboard,
    icon: <Home color="white" />,
  },
  {
    label: "Search Job",
    link: routeNames.jobSeeker.searchJob,
    icon: <Plus color="white" />,
  },
  {
    label: "Search People",
    link: routeNames.jobSeeker.searchPeople,
    icon: <Briefcase color="white" />,
  },
  {
    label: "Search Company",
    link: routeNames.jobSeeker.searchCompany,
    icon: <Search color="white" />,
  },
];
export const internalLinks = [
  {
    label: "Edit Profile",
    link: routeNames.jobSeeker.myProfile,
    icon: <Edit size={22} />,
  },
  {
    label: "Settings",
    link: routeNames.jobSeeker.settings,
    icon: <Adjustments size={22} />,
  },
];
